// extracted by mini-css-extract-plugin
export default {"nav":"InvoiceTabs_nav__VZRN9","navList":"InvoiceTabs_navList__UyMkP","links":"InvoiceTabs_links__QleRq","active":"InvoiceTabs_active__4BwdI"};